import { Stepper } from "@/components/fly/Stepper";

export const penaltyHint = (d) => {
  if (d.kind === "flag") return `−${d.unit} pkt`;
  if (d.kind === "count") return `−${d.unit} pkt za każdy (maks. ${d.max}× = −${d.unit * d.max} pkt)`;
  return d.max > 1 ? `−1 do −${d.max} pkt` : "−1 pkt";
};

export const PenaltyRow = ({ def, value, onChange }) => {
  const testid = `penalty-${def.key}`;
  if (def.kind === "flag") {
    const on = value > 0;
    return (
      <div className="flex items-center justify-between gap-4 py-3 border-b border-white/5 last:border-0">
        <Label def={def} />
        <button type="button" data-testid={`${testid}-toggle`} onClick={() => onChange(on ? 0 : 1)}
          className={`h-12 px-5 rounded-xl border font-display text-xl font-bold transition-colors ${on ? "bg-red-500/20 border-red-500 text-red-300" : "border-white/10 text-slate-500"}`}>
          {on ? `−${def.unit}` : "brak"}
        </button>
      </div>
    );
  }
  return (
    <div className="flex items-center justify-between gap-4 py-3 border-b border-white/5 last:border-0 flex-wrap">
      <Label def={def} />
      <Stepper value={value} onChange={onChange} min={0} max={def.max} step={1} tone="red" testid={testid}
        display={(v) => (def.kind === "count" ? `${v}×` : v ? `−${v}` : "0")} />
    </div>
  );
};

const Label = ({ def }) => (
  <div className="min-w-0 flex-1">
    <div className="text-sm text-slate-200">{def.label}</div>
    <div className="text-xs font-mono text-red-400/80">{penaltyHint(def)}</div>
  </div>
);
